import React from 'react';
import { IPerYearAndMonthRankingsType } from '../actions/StatsActions';
import PerYearAndMonthSortedBarChart from './charts/PerYearAndMonthSortedBarChart';
import * as am4core from "@amcharts/amcharts4/core";

export interface IPerYearAndMonthLeaderboardProps {
  id: string;
  title: string;
  data: Array<IPerYearAndMonthRankingsType>;
}

const PerYearAndMonthLeaderboard: React.FC<IPerYearAndMonthLeaderboardProps> = (props: IPerYearAndMonthLeaderboardProps) => {
  let colors: am4core.Color[] = [
    am4core.color("#4A005E"),
    am4core.color("#6D005E"),
    am4core.color("#90005E"),
    am4core.color("#B5005E"),
    am4core.color("#D8005E"),
    am4core.color("#FF005E"),
    am4core.color("#FF3D5E"),
    am4core.color("#FF605E"),
    am4core.color("#FF7C5E"),
    am4core.color("#FF9C5E"),
  ];

    return (
      <div className="PerYearAndMonthLeaderboard">
        <p className="LeaderboardCenteredTitle">{props.title}</p>
        <PerYearAndMonthSortedBarChart id={props.id} colors={colors} data={props.data} />
      </div>
    );
  }
  
  export default PerYearAndMonthLeaderboard;